module.exports = __webpack_public_path__ + "assets/static/png/icons_board.d9ea442c9b46ed4c370f6a3b23f803ad.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myCards/images/icons_board.png
 ** module id = 23
 ** module chunks = 1
 **/